import { deleteConversationsFromTable } from './deleteConversations';
import { deleteItemsFromTable } from './deleteItems';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { ActionSource } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Method removes given rows from the given tableView
 * @param rowKeys - rowKeys of the tableView to be removed from
 * @param originalTableViewId - source tableView id
 * @param isExplicitSoftDelete - flag for explicite soft delete
 * @param actionSource - source of the action
 */
export default function deleteMailListRows(
    rowKeys: string[],
    originalTableViewId: string,
    isExplicitSoftDelete: boolean,
    actionSource?: ActionSource
) {
    const tableView = listViewStore.tableViews.get(originalTableViewId);
    const instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            deleteConversationsFromTable(
                rowKeys,
                originalTableViewId,
                isExplicitSoftDelete,
                instrumentationContexts,
                actionSource
            );
            break;

        case ReactListViewType.Message:
            deleteItemsFromTable(
                rowKeys,
                originalTableViewId,
                isExplicitSoftDelete,
                instrumentationContexts,
                actionSource
            );
            break;
    }
}
